type Locale = "zh-CN" | "en";

const loginErrors: Record<string, Record<Locale, string>> = {
  INVALID_CREDENTIALS: {
    "zh-CN": "账号或密码错误。",
    en: "Incorrect username or password.",
  },
  LOGIN_RATE_LIMITED: {
    "zh-CN": "登录尝试过多，请稍后重试。",
    en: "Too many sign-in attempts. Try again later.",
  },
  TURNSTILE_FAILED: {
    "zh-CN": "安全验证失败，请重试。",
    en: "Security verification failed. Try again.",
  },
  SECURITY_CONFIG_LOAD_FAILED: {
    "zh-CN": "安全配置加载失败。",
    en: "Security config failed to load.",
  },
  SECURITY_CONFIG_LOADING: {
    "zh-CN": "正在加载安全配置，请稍候。",
    en: "Loading security config. Please wait.",
  },
  SECURITY_CONFIG_UNAVAILABLE: {
    "zh-CN": "安全验证配置不可用。",
    en: "Security verification is unavailable.",
  },
  TURNSTILE_REQUIRED: {
    "zh-CN": "请先完成安全验证。",
    en: "Complete the security check first.",
  },
  LOGIN_FAILED: {
    "zh-CN": "登录失败。",
    en: "Sign-in failed.",
  },
};

export function loginErrorMessage(code: string, locale: Locale, fallback: string) {
  return loginErrors[code]?.[locale] ?? fallback;
}
